import { LocalDate } from '@js-joda/core';

import { getCurrentTimezone } from '@dreryk/react-common';

const getDatePart = (parts: Intl.DateTimeFormatPart[], type: Intl.DateTimeFormatPartTypes): number => {
   return Number(parts.find((part) => part.type === type)?.value);
};

export const getIssuedFromDefaultValue = (): LocalDate => {
   const parts = new Intl.DateTimeFormat('en', {
      timeZone: getCurrentTimezone(),
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
   }).formatToParts(new Date());

   return LocalDate.of(getDatePart(parts, 'year'), getDatePart(parts, 'month'), getDatePart(parts, 'day'));
};

export const isIssuedFromInThePast = (issuedFrom: LocalDate): boolean => {
   return issuedFrom.isBefore(getIssuedFromDefaultValue());
};
